import { CustomLink } from "@/components";
import { type ButtonProps, buttonVariants } from "@/components/ui/button";
import { cn } from "@/services/hooks/utils";
import type { LinkProps } from "@tanstack/react-router";

interface ButtonCustomLinkProps extends LinkProps {
    variant?: ButtonProps["variant"];
    className?: string;
}

const ButtonCustomLink = ({
    to,
    variant = "default",
    className,
    children,
    ...props
}: ButtonCustomLinkProps) => {
    return (
        <CustomLink
            to={to}
            className={cn(buttonVariants({ variant }), "w-full", className)}
            {...props}
        >
            {children}
        </CustomLink>
    );
};

export default ButtonCustomLink;
